import { render, staticRenderFns } from "./AppointmentReminder.vue?vue&type=template&id=80bcaaec&"
import script from "./AppointmentReminder.vue?vue&type=script&lang=ts&"
export * from "./AppointmentReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports